export const people = {
  title: "Personas",
  description:
    "Quién entra en Punto.Firma con Google. Además del dominio, cada persona tiene que estar invitada.",
  tabs: {
    users: "Usuarios",
    groups: "Grupos",
  },
  user: "Persona",
  group: "Grupo",
  you: "Tú",
  invite: {
    button: "Invitar",
    title: "Invitar a una persona",
    description:
      "Entrará con su cuenta de Google con este email. No hay enlace mágico: pasa de invitada a activa en su primer acceso.",
    email: "Email",
    emailPlaceholder: "nombre@{{domain}}",
    emailHint: "Tiene que ser de {{domains}}.",
    name: "Nombre (opcional)",
    role: "Rol",
    roleHints: {
      admin:
        "Gestiona certificados, políticas, personas y ve toda la actividad.",
      user: "Ve sus certificados y su actividad, y los usa desde la app de Mac.",
    },
    groups: "Grupos (opcional)",
    submit: "Invitar",
    success: "Invitación creada para {{email}}",
    errors: {
      email: "Escribe un email válido.",
    },
  },
  users: {
    search: "Buscar por email o nombre",
    filters: {
      status: "Estado",
      role: "Rol",
      group: "Grupo",
    },
    columns: {
      person: "Persona",
      role: "Rol",
      status: "Estado",
      groups: "Grupos",
      lastLogin: "Último acceso",
    },
    empty: "Todavía no hay nadie más",
    emptyDescription:
      "Invita a tu equipo para que pueda usar los certificados.",
    invited: "Invitado {{when}}",
  },
  groups: {
    new: "Nuevo grupo",
    newTitle: "Nuevo grupo",
    newDescription:
      "Un grupo sirve para dar acceso en una política a varias personas a la vez.",
    name: "Nombre",
    namePlaceholder: "Fiscal",
    descriptionLabel: "Descripción (opcional)",
    members: "Personas (opcional)",
    create: "Crear grupo",
    created: "Grupo «{{name}}» creado",
    search: "Buscar grupos",
    columns: {
      name: "Nombre",
      description: "Descripción",
      members: "Personas",
    },
    empty: "Todavía no hay grupos",
    emptyDescription:
      "Crea grupos («Fiscal», «Laboral»…) para dar acceso a varias personas a la vez.",
    errors: {
      name: "Ponle un nombre.",
    },
  },
  userDetail: {
    notFound: "Esta persona no está en la organización.",
    changeRole: "Cambiar rol",
    changeRoleTo: "Pasar a {{role}}",
    roleChanged: "Ahora es {{role}}",
    suspend: "Suspender",
    suspendTitle: "¿Suspender a {{name}}?",
    suspendDescription:
      "Corta al instante: se cierran sus sesiones en la web y en la app de Mac, y la siguiente firma con cualquier certificado se deniega. No se borra nada y se puede reactivar.",
    suspendConfirm: "Suspender ahora",
    suspended: "{{name}} está suspendida: ya no puede firmar.",
    suspendedNote:
      "Suspendida {{when}}. No puede entrar ni firmar con ningún certificado.",
    reactivate: "Reactivar",
    reactivated: "{{name}} puede volver a entrar.",
    remove: "Quitar de la organización",
    removeTitle: "¿Quitar a {{name}} de la organización?",
    removeDescription:
      "Pierde el acceso a todo: sale de sus grupos y de las políticas que la nombran, y se cierran sus sesiones. Su registro de actividad se conserva.",
    removeConfirm: "Quitar",
    removed: "{{name}} ya no está en la organización",
    lastLogin: "Último acceso: {{when}}",
    neverLoggedIn: "Todavía no ha entrado",
    sessionsOpen_one: "{{count}} sesión abierta en la app",
    sessionsOpen_other: "{{count}} sesiones abiertas en la app",
    tabs: {
      access: "Acceso",
      groups: "Grupos ({{count}})",
      activity: "Actividad",
      sessions: "Sesiones",
    },
  },
  access: {
    intro: "Qué certificados puede usar y por qué.",
    columns: {
      certificate: "Certificado",
      where: "Dónde",
      by: "Por",
    },
    except: "excepto {{what}}",
    withExceptions: "con excepciones",
    byGroup: "grupo {{name}}",
    empty: "No puede usar ningún certificado",
    emptyDescription:
      "Ninguna política le da acceso, ni directamente ni por un grupo.",
  },
  userGroups: {
    add: "Añadir a un grupo",
    choose: "Elige un grupo",
    added: "Añadida al grupo «{{name}}»",
    removed: "Quitada del grupo «{{name}}»",
    empty: "No está en ningún grupo",
    emptyDescription:
      "Los grupos dan acceso en las políticas a varias personas a la vez.",
  },
  userActivity: {
    signatures: "Últimas firmas",
    navigation: "Última navegación",
    seeAll: "Ver todo en Actividad",
    empty: "Sin actividad todavía",
    columns: {
      when: "Cuándo",
      what: "Qué",
      result: "Resultado",
    },
  },
  sessions: {
    intro:
      "Macs donde la app de Punto.Firma ha entrado con esta cuenta. Cerrar una sesión obliga a ese Mac a volver a entrar.",
    columns: {
      device: "Mac",
      created: "Desde",
      lastUsed: "Último uso",
      expires: "Caduca",
    },
    close: "Cerrar",
    closeTitle: "¿Cerrar la sesión de «{{device}}»?",
    closeDescription:
      "La app de ese Mac deja de poder firmar hasta que vuelva a entrar.",
    closeConfirm: "Cerrar sesión",
    closed: "Sesión cerrada",
    empty: "Sin sesiones abiertas",
    emptyDescription: "No ha entrado en la app de Mac, o ya se cerraron.",
    unknownDevice: "Mac sin nombre",
  },
  groupDetail: {
    notFound: "Este grupo no existe.",
    edit: "Editar",
    editTitle: "Editar el grupo",
    saved: "Grupo guardado",
    delete: "Borrar grupo",
    deleteTitle: "¿Borrar el grupo «{{name}}»?",
    deleteDescription:
      "Las políticas que lo usan dejan de aplicarse a sus miembros. Las personas no se borran.",
    deleteConfirm: "Borrar",
    deleted: "Grupo «{{name}}» borrado",
    members: "Personas",
    addMember: "Añadir persona",
    choosePerson: "Elige una persona",
    memberAdded: "{{name}} añadida al grupo",
    memberRemoved: "{{name}} quitada del grupo",
    removeMember: "Quitar a {{name}} del grupo",
    membersEmpty: "El grupo está vacío",
    membersEmptyDescription:
      "Añade personas para que reciban el acceso de sus políticas.",
    policies: "Políticas que lo usan",
    policiesEmpty: "Ninguna política lo usa todavía.",
  },
};
